<div class="custom-tooltip">
  <div class="header">
    <span>{{data.indexName}}</span>
    <i class="icon-close-thin pointer-cursor" (click)="closeTooltip()"></i>
  </div>
  <div class="content">
    <table>
      <tr>
        <td>Region</td>
        <td>{{data.region.includes(',') ? 'Global' : data.region}}</td>
      </tr>
      <tr>
        <td>Index Family</td>
        <td>{{data.indexFamily}}</td>
      </tr>
      <tr>
        <td>ISIN</td>
        <td>{{data.isinTri}}</td>
      </tr>
      <tr>
        <td>Bloomberg Ticker</td>
        <td>{{data.bloombergTicker}}</td>
      </tr>
      <tr *ngIf="data.investmentType.includes('Standardized_TRS')">
        <td>Markit RED ID</td>
        <td>{{data.redId}}</td>
      </tr>
      <tr>
        <td>Base Date</td>
        <td>{{data.baseDate}}</td>
      </tr>
    </table>
  </div>
</div>
